export enum StandWorksheetForm {
  CancelOpenStandWorksheets = 'rawC',
  PrintOpeningSheets = 'UPtv',
  PhysTerminalSalesDiff = 'GHhJ',
  PhysTerminalSalesDiffPercent = 'bH3l',
  EventDateTime = 'F11g',
  SalesOrderDetails = 'tPkz',
  OrderNumber = 'kiK/',
  CloseDateTime = '8XmW',
  OrderType = '6s6Q',
  IngredientSpoil = 'wrH2',
  Gratis = 'EvH1',
  ProductCount = 'jjFM',
  Refund = 'aze9',
  Sale = 'PyUA',
  VoidedPostPayment = 'VxMe',
  InformationData = '2i+J',
  PhysicalSales = '2Yfo',
  TerminalSales = '2Yls',
  PhysTerminalDiff = 'Jz0m',
  TotalTaxes = '13St',
  CashCount = 'GynD',
  ReceiptPhysicalDiff = '4+Ei',
  CreditGiftCards = '2cHh',
  TerminalCash = '/0E3',
  CustomTenders = 'bXZz',
  Tips = 'ODik',
  TotalDiscounts = '671o',
  FeesOther = 'Xb85',
  PostClosureSales = 'wxnj',
  TotalPostClosureTaxes = 'CHHM',
  PostClosureCustom = 'PjV2',
  PostClosureTips = 'MR+h',
  PostClosureTerminalCash = 'WHFa',
  TotalPostClosureDiscounts = 'v9OJ',
  EntryForm = '8lym',
  EditCounts = 'GGOs',
  ExitEditCounts = 'MIid',
  SummaryView = 'p3WZ',
  ShowEntryFormPage = '/wi0',
  WriteZerosToBlankEndingCounts = '5eI9',
  WriteBeginCountsToBlankEndingCounts = 'IoK+',
  WriteExpectedQuantitiesToBlankEndingCounts = 'kOk9',
  TransferIn = 'hlno',
  TransferOut = 'NFZ4',
  BeginCnt = 'oLkM',
  PreIn = '5vr1',
  MgrOvrd = 'f1Z9',
  TotalAvail = 'bGYg',
  DuringIn = 'SEYV',
  DuringOut = 'RxhB',
  Spoilage = 'i3Ht',
  Adj = 'AXz5',
  ExpQty = '5gEO',
  EndCnt = 'TsE+',
  TermQty = 't1wJ',
  PhysQty = 'ua6m',
  PriceAdj = 'GmJN',
  Taxes = 'c/iT',
  Disc = 'DDri',
  PostClsQty = '+/OI',
  PostClsTaxes = '5j2t',
  PostClsDisc = 'fz0b',
  VarQty = '8ne/',
  PreEventIn = 'NdHt',
  MGRStartingOverride = 'HMSz',
  TotalAvailable = 'fku7',
  DuringEventIn = 'PieA',
  DuringEventOut = '95Zl',
  Adjustment = 'xBYG',
  ExpectedQty = '+ssS',
  EndingCount = 'g4io',
  TerminalQty = 'HXbg',
  TerminalDollars = 'COPJ',
  PhysicalDollars = 'TQ+P',
  PriceAdjustment = 'Y/Vz',
  Discounts = 'u/Re',
  PostClosureQty = 'Rftn',
  PostClosureDollars = 'cqW8',
  PostClosureTaxes = '1YFb',
  PostClosureDiscounts = 'exmB',
  VarianceQty = 'Q7dy',
  VarianceDollars = '6krt',
  TotalPostClosure = 'D0MQ',
  PostClosureGratis = 'mHH7',
  PostClosureSpoilage = 'aJrv',
  StandWorksheetOpening = 'Cspw',
  BeginCount = 'zbou',
  AuditSignature = '8PnS',
  StandSupervisorSignature = 'vKkp',
  SumOfDollarsPaidByCash = 'pRla',
  Term = '7idD',
  Phys = 'tQYy',
  Var = '4R5q',
  PostCls = 'feYK',
  PostClosureGiftCards = '9NF+',
}

export enum StandWorksheetFormTips {
  OrderNumberTip = 'pR7c',
  PhysicalSalesTip = 'ewPz',
  PhysTerminalDiffTip = 'Bz3D',
  TotalTaxesTip = 'YVOf',
  CashCountTip = 'PVvJ',
  CreditGiftCardsTip = 'AYkS',
  TerminalCashTip = 'M4Jz',
  CustomTendersTip = 'XQze',
  TipsTip = 'rFSi',
  TotalDiscountsTip = 'sqP3',
  FeesOtherTip = 'pnH0',
  PostClosureSalesTip = 'M1Vz',
  TotalPostClosureTaxesTip = 'OO7u',
  PostClosureCreditGiftCardsTip = 'eRSm',
  PostClosureCustomTip = 'lQvv',
  PostClosureTipsTip = 'ZYPx',
  PostClosureTerminalCashTip = 'PBlr',
  TotalPostClosureDiscountsTip = 'VlGV',
  ReceiptPhysicalDiffTip = 'C1WV+',
  ReceiptPhysicalDiffTipV2 = 'YtMd',
  UnitPriceTip = 'MVIm',
  DuringOutTip = 'Va+f',
  GratisTip = '0KoV',
  SpoilageTip = 'g2Fn',
  AdjustmentTip = 'HGu8',
  ExpectedQtyTip = '83HR',
  ExpectedQtyTipV2 = 'DwCP',
  EndCntTip = 'k+w/',
  TermQtyTip = 'Ri+u',
  Term$Tip = 'XkVN',
  PhysQtyTip = 'nE0u',
  Phys$Tip = 'DyuG',
  PriceAdjTip = 'jNwe',
  PriceAdjTipV2 = 'tAIe',
  TaxesTip = '3HgL',
  DiscTip = 'tGAK',
  PostClsQtyTip = '64Fj',
  PostCls$Tip = 'W/RE',
  PostClsTaxesTip = 'bF5j',
  PostClsDiscTip = '7iXy',
  VarianceQtyTip = 'hcY0',
  Var$Tip = 'uM1j',
  BeginCntTip = 'KJ7E',
  PreInTip = 'xkKV',
  MgrOvrdTip = '5qZs',
  TotalAvailTip = '3b0h',
  DuringInTip = '0F5W',
  TerminalSalesTip = '95HN',
  ReceiptPhysicalDiffWithOffPostClosureTip = 'Pksv',
  ReceiptPhysicalDiffWithOffPostClosureTipV2 = 'woNk',
  PercentageExceedsThresholdTip = 'veiP',
  TerminalSalesTipV2 = 'j+PY',
  StandWorksheetReinitializedTooltipMessage = 'UD/S',
}

export enum StandWorksheetFormErrors {
  FailedToWriteEndingCounts = 'cInT',
}
